import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNotification } from '../contexts/NotificationContext';
import './BirdNotification.css';

function BirdNotification() {
  const { notification, isVisible, dismissNotification } = useNotification();
  const location = useLocation();
  const navigate = useNavigate();

  // Only show on home page
  if (location.pathname !== '/home') {
    return null;
  }

  if (!isVisible || !notification) {
    return null;
  }

  const handleDismiss = (e) => {
    e.stopPropagation();
    dismissNotification();
  };

  const handleBirdClick = () => {
    dismissNotification();
    navigate('/poetry');
  };

  return (
    <div className="bird-notification-container">
      <div className="bird-notification" onClick={handleBirdClick} style={{ cursor: 'pointer' }}>
        {/* Bird on branch */}
        <div className="bird-on-branch">
          <div className="branch"></div>
          <div className="bird">
            <div className="bird-body"></div>
            <div className="bird-head"></div>
            <div className="bird-beak"></div>
            <div className="bird-eye"></div>
            <div className="bird-wing"></div>
            <div className="bird-tail"></div>
          </div>
        </div>

        {/* Speech bubble */}
        <div className="speech-bubble">
          <p className="bubble-text">
            You have unread poems!
          </p>
          <div className="bubble-tail"></div>
        </div>

        {/* Dismiss button */}
        <button
          className="dismiss-button"
          onClick={handleDismiss}
          aria-label="Dismiss notification"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default BirdNotification;
